import React, { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { csx, Text } from '@vtex/admin-ui'
import ScheduledDeliveryModal from '@vtexlab/scheduled-delivery'
import { filterLogisticsInfo } from '@vtex/delivery-packages/dist/shipping'

import { useOrderForm } from '../../../../../../core/requests/checkout'
import type { Package } from '../../../../../../core/typings'
import { useShippingActionsLegacy } from '../../../../../../checkout-instore-bridge/hooks/shippingActionsLegacy'

export type ScheduledDeliveryModalProps = {
  selectedSla?: SLA
  selectedDate?: Date
  selectedTime?: string
}

export type ScheduleDeliveryButtonProps = {
  selectedPackage?: Package
}

export const ScheduleDeliveryButton = ({
  selectedPackage,
}: ScheduleDeliveryButtonProps) => {
  const [isScheduleModalVisible, setIsScheduleModalVisible] = useState(false)
  const { orderForm } = useOrderForm()
  const { sendNewScheduledDeliveryChoice } = useShippingActionsLegacy()
  const intl = useIntl()

  const isSchedulable = () => {
    return (
      selectedPackage?.selectedSlaObj?.availableDeliveryWindows &&
      selectedPackage.selectedSlaObj.availableDeliveryWindows.length > 0
    )
  }

  const isScheduled =
    selectedPackage?.selectedSlaObj &&
    !!selectedPackage?.selectedSlaObj.deliveryWindow

  const scheduledDeliveryPkgLogisticsInfo = selectedPackage?.items
    ? filterLogisticsInfo(orderForm?.shippingData.logisticsInfo, {
        items: selectedPackage.items,
      })
    : null

  const handleOnCloseScheduledDeliveryModal = () => {
    setIsScheduleModalVisible(false)
  }

  const handleConfirmScheduledDeliveryModal = ({
    deliveryWindow,
    selectedSla,
  }: {
    deliveryWindow: any
    selectedSla: SLA
  }) => {
    const pkg = selectedPackage

    if (!pkg) return
    const { items } = pkg

    sendNewScheduledDeliveryChoice({
      items,
      deliveryWindow,
      selectedSla,
    })
  }

  return (
    <div className={csx({ display: 'flex', alignItems: 'center' })}>
      {isSchedulable() && (
        <>
          <ScheduledDeliveryModal
            title={intl.formatMessage({
              id: 'checkout.shipping-method-selection.schedule-delivery-title',
            })}
            visible={isScheduleModalVisible}
            items={selectedPackage?.items}
            logisticsInfo={scheduledDeliveryPkgLogisticsInfo}
            storePreferencesData={orderForm?.storePreferencesData}
            deliveryWindow={selectedPackage?.deliveryWindow}
            selectedSla={selectedPackage?.selectedSla}
            onClose={handleOnCloseScheduledDeliveryModal}
            onConfirm={handleConfirmScheduledDeliveryModal}
            locale={intl.locale}
          />
          <Text
            onClick={() => setIsScheduleModalVisible(true)}
            className={csx({
              alignItems: 'center',
            })}
          >
            <span
              className={csx({
                cursor: 'pointer',
                color: '$action.main.secondary',
              })}
            >
              <FormattedMessage
                id={
                  !isScheduled
                    ? 'checkout.shipping-method-selection.schedule-delivery'
                    : 'checkout.shipping-method-selection.change-scheduled-delivery'
                }
              />
            </span>
          </Text>
        </>
      )}
    </div>
  )
}
